export enum ID_UPLOADER_DIALOG {
  NO_PHOTO = 'Upload or drag a photo here',
}
